import { render, staticRenderFns } from "./chatform.vue?vue&type=template&id=78edfa54"
import script from "./chatform.vue?vue&type=script&lang=js"
export * from "./chatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports